import { HttpModule } from '@nestjs/axios'
import { Module } from '@nestjs/common'
import { SequelizeModule } from '@nestjs/sequelize'
import { WebhookAplicacionService } from '../plataforma/services/aplicacion.server.services'
import { WebhookMensajeController } from './controllers/facebook/dispatcher/mensaje.controller'
import { WebhookMensajeRecibidoController } from './controllers/facebook/listener/mensaje-recibido.controller'
import { WebhookDispatcherMensajeSmsController } from './controllers/sms/dispatcher/mensaje.controller'
import { WebhookDispatcherMensajeWhatsappController } from './controllers/whatsapp/dispatcher/mensaje.controller'
import { WebhookMensajeRecibidoWhatsappController } from './controllers/whatsapp/listener/mensaje-recibido.controller'
import { MensajeRecibidoModel } from './models/mensaje-recibido.model'
import { TipoMensajeModel } from './models/tipo-mensaje.model'
import { WebhookListenerService } from './services/listener.server.services'
import { WebhookSmsServerService } from './services/sms/sms.server.service'
import { WebhookTipoMensajeService } from './services/tipo-mensaje.server.services'
import { WebhookWhatsappServerService } from './services/whatsapp/whatsapp.server.service'

@Module({
  controllers: [
    WebhookDispatcherMensajeWhatsappController,
    WebhookMensajeRecibidoController,
    WebhookMensajeController,
    WebhookMensajeRecibidoWhatsappController,
    WebhookDispatcherMensajeSmsController,
  ],
  imports: [HttpModule, SequelizeModule.forFeature([TipoMensajeModel, MensajeRecibidoModel])],
  providers: [
    WebhookListenerService,
    WebhookTipoMensajeService,
    WebhookWhatsappServerService,
    WebhookSmsServerService,
    WebhookAplicacionService,
  ],
})
export class WebhookServerModule {}
